import { StepIdentifier } from "features/subscription-process/types/enums"

export interface StepDirection {
  identifier: StepIdentifier
  route: string
  disabled?: boolean
  label?: string
  onClick?: () => void
}

export interface StepConfig {
  next?: StepDirection
  prev?: StepDirection
}

export type BranchStepConfigFactory = (riskId: string) => StepConfig

export const createStepConfig = (config: {
  next?: StepDirection,
  prev?: StepDirection
}): BranchStepConfigFactory => {
  return (riskId: string) => ({
    next: config.next
      ? {
        identifier: config.next.identifier,
        route: `${config.next.route}/${riskId}`,
        label: config.next.label,
        disabled: config.next.disabled,
        onClick: config.next.onClick,
      }
      : undefined,
    prev: config.prev
      ? {
        identifier: config.prev.identifier,
        route: `${config.prev.route}/${riskId}`,
        label: config.prev.label,
        disabled: config.prev.disabled,
        onClick: config.prev.onClick,
      }
      : undefined,
  })
}

